import React from 'react';
import moment from 'moment';
import { Tag } from 'antd';

const cols = (t) => [
  {
    title: t('ID'),
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    show: true,
  },
  {
    title: t('Name'),
    dataIndex: 'organisationName',
    key: 'organisationName',
    defaultSortOrder: 'ascend',
    sorter: (a, b) => ('' + a?.organisationName).localeCompare(b?.organisationName),
    show: true,
    primarySearch: true,
  },
  {
    title: t('Category'),
    dataIndex: 'category',
    key: 'category',
    sorter: (a, b) => ('' + a.category).localeCompare(b.category),
    show: true,
    search: true,
    searchType: 'dropdown',
  },
  {
    title: t('Type'),
    dataIndex: 'type',
    key: 'type',
    show: true,
    render: data => t(data),
  },
  {
    title: t('Subjects'),
    dataIndex: 'subjects',
    key: 'subjects',
    show: true,
    render: data => data.map(d => <Tag>{d}</Tag>),
  },
  {
    title: t('Last Update'),
    dataIndex: 'lastUpdate',
    key: 'lastUpdate',
    show: true,
    render: lastUpdate => lastUpdate ? moment(lastUpdate).format('DD MMM YYYY') : '-',
  },
  // {
  //   title: t('Sub Category'),
  //   dataIndex: 'subCategory',
  //   key: 'subCategory',
  //   sorter: (a, b) => ('' + a.subCategory).localeCompare(b.subCategory),
  //   show: false,
  //   search: true,
  //   searchType: 'dropdown',
  // },
  // {
  //   title: t('Primary Location'),
  //   dataIndex: 'primaryLocation',
  //   key: 'primaryLocation',
  //   show: true,
  //   search: true,
  // },
  // {
  //   title: t('Date joined'),
  //   dataIndex: 'dateJoined',
  //   key: 'dateJoined',
  //   show: true,
  //   render: date => date ? moment(date).format('DD MMM YYYY') : '',
  // },
  // {
  //   title: t('Number of assessments'),
  //   dataIndex: 'nrOfAssessments',
  //   key: 'nrOfAssessments',
  //   show: true,
  // },
  // {
  //   title: t('Number of events'),
  //   dataIndex: 'nrOfEvents',
  //   key: 'nrOfEvents',
  //   show: true,
  // },
]

export default cols;
